import { FC, useCallback } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { SizeChartModalService } from '../../../../../../brunswick/containers/SizeChartModalService'
import { nullSizeChart } from '../../../../../../constants'
import { trackEvent } from '../../../../../../lib/analytics'
import { SizeChart as SizeChartType } from '../../../../../../types/graphql'

import { SizeChartButton } from './styles'

interface Props {
  category: string
  sizeChart?: SizeChartType
  hideTitle?: boolean
}

export const SizeChart: FC<Props> = ({ category, sizeChart: providedSizeChart, hideTitle }) => {
  const sizeChart = providedSizeChart?.name === nullSizeChart ? undefined : providedSizeChart

  const { openSizeChartModal } = SizeChartModalService.useContainer()

  const revealSizeChartModal = useCallback(() => {
    sizeChart && openSizeChartModal(sizeChart, 0)
  }, [sizeChart, openSizeChartModal])

  const {
    sizesSection: { sizeChartCTA },
  } = useTranslation()

  if (!sizeChart || hideTitle) return null

  return (
    <SizeChartButton
      onClick={revealSizeChartModal}
      aria-label={sizeChartCTA}
      {...trackEvent({ category, action: 'open size chart' })}
    >
      {sizeChartCTA}
    </SizeChartButton>
  )
}
